import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";

import { InternshipsAction } from "../../store/actions";
import { Buttons, Modal } from "..";

const UploadJobs = ({ text = "Upload", width = "8em" }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const { isLoading } = useSelector((state) => state?.internships);
  const [modalVisible, setModalVisible] = useState(false);

  const handleUpload = (file) => {
    if (!file) return;

    const formdata = new FormData();
    formdata.append("file", file);

    const key = "uploadMessage";
    message.loading({
      content: "Data is being updated in the backend",
      key,
      duration: 0,
    });

    dispatch(
      InternshipsAction.uploadInternships(formdata, (res) => {
        if (res.status === 200) {
          message.success({
            content: "Data updated successfully",
            key,
            duration: 2,
          });
          dispatch(InternshipsAction.getInternships({}));
        } else {
          message.error({
            content: res.message,
            key,
            duration: 2,
          });
        }
      })
    );
    setModalVisible(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className={`${width}`}>
      <Buttons.DefaultButton
        size="medium"
        width="full"
        onClick={() => setModalVisible(true)}
        disabled={isLoading}
      >
        {text}
      </Buttons.DefaultButton>
      <Modal.DefaultModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
      >
        <div className="w-[35em] flex flex-col gap-4 justify-center items-center">
          <div className="text-main font-bold text-[2em]">
            Upload Internships
          </div>
          <div className="w-full">
            <div
              className="cursor-pointer border border-dashed border-main rounded-xl p-5 text-center w-full"
              onClick={() => fileInputRef.current?.click()}
            >
              Select File
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              accept=".xlsx"
              ref={fileInputRef}
              onChange={(event) => handleUpload(event.target.files[0])}
            />
          </div>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default UploadJobs;
